import { DataGrid, GridColDef, GridRowModel, GridSingleSelectColDef, GridValueOptionsParams } from "@mui/x-data-grid";
import { AdminUserPickSummaryResponse, AdminUserResponse, User } from "../../models/AdminModels";
import { Alert, Box, Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { ReactNode, useCallback, useEffect, useState } from "react";
import axios from "axios";
import { UIPick, UpdatePicksRequest, UpdatePicksResponse } from "models/Models";
import * as PickService from "services/PickService";

import "./AdminImpersonate.scss";

export const AdminImpersonate = () => {
  const [user, setUser] = useState<User>();
  const [users, setUsers] = useState<User[]>([]);
  const [picks, setPicks] = useState<UIPick[]>([]);
  const [errors, setErrors] = useState<string[]>([]);
  const [picksUpdated, setPicksUpdated] = useState<number>();

  useEffect(() => {
    //TODO:DF Local loading indicator
    axios.get<AdminUserResponse>(`${process.env.REACT_APP_API_URL}/admin/users`).then((r) => {
      r.data.users.sort((a,b) => a.teamName > b.teamName ? 1 : -1);
      setUsers(r.data.users);
    });
  }, []);


  const columns: GridColDef[] = [
    {
      field: "homeTeamName",
      headerName: "Home",
      width: 150,
      editable: false,
    },
    {
      field: "awayTeamName",
      headerName: "Away",
      width: 150,
      editable: false,
    },
    {
      field: "teamId",
      headerName: "Pick",
      type: 'singleSelect',
      width: 150,
      editable: true,
      valueOptions: ((params: GridValueOptionsParams<UIPick>) => [{ label: "None", value: 0 }, { label: params.row!.homeTeamName, value: params.row!.homeTeamId }, { label: params.row!.awayTeamName, value: params.row!.awayTeamId }]) as any
    } as GridSingleSelectColDef<UIPick>,
    {
      field: "games",
      headerName: "Games",
      type: 'number',
      editable: true,
      width: 90,
    },
  ];

  const createUIPicks = (data: AdminUserPickSummaryResponse, user: User) => {
    const picks = PickService.createUIPicks(data);
    picks.forEach(p => p.userId = user.userId);
    return picks;
  };

  const handleUserChange = (event: SelectChangeEvent<string>, child: ReactNode): void => {
    const user = users.find(c => c.username === event.target.value);
    setUser(user);
    if (!user) {
      setPicks([]);
    } else {
      axios.get<AdminUserPickSummaryResponse>(`${process.env.REACT_APP_API_URL}/admin/user/${user.userId}/picks`).then((r) => {
        const picks = createUIPicks(r.data, user);
        setPicks(picks);
      });
    }
  };

  const processRowUpdate = useCallback(
    async (newRow: GridRowModel) => {
      // Make the HTTP request to save in the backend
      const match = picks.find(c => c.seriesId === newRow.seriesId);
      if (match) {
        columns.forEach((c) => {
          if (c.editable) {
            (match as any)[c.field] = newRow[c.field];
          }
        })
      }
      return match;
    },
    [picks, columns],
  );

  const update = async () => {
    //TODO:DF local loading indicator
    const result = await axios.put<UpdatePicksResponse>(`${process.env.REACT_APP_API_URL}/admin/picks`, { userId: user?.userId, picks: picks } as UpdatePicksRequest);
    setErrors(result.data.errors);
    if (!result.data.errors || result.data.errors.length === 0)
      setPicksUpdated(result.data.updateCount);
    else
      setPicksUpdated(undefined);
    var uipicks = createUIPicks(result.data, user!);
    setPicks(uipicks);
  };

  return (
    <div className="admin-impersonate">
      <div className="command-list">
        <FormControl sx={{ m: 1, minWidth: 220 }} size="small">
          <InputLabel>Impersonate</InputLabel>
          <Select
            value={user?.username || ""}
            label="Team"
            onChange={handleUserChange}
          >
            <MenuItem value={""}>
              <em>None</em>
            </MenuItem>
            {users.map((u) => <MenuItem key={u.userId} value={u.username}>{u.teamName} ({u.username})</MenuItem>)}
          </Select>
        </FormControl>
        <Button variant="outlined" size="small" onClick={update}>
          Save
        </Button>
      </div>
      <div className="alerts">
        {errors.length > 0 && <div>{errors.map(e => <Alert key={e} severity="error">{e}</Alert>)}</div>}
        {picksUpdated !== undefined && <Alert severity="success" onClose={() => setPicksUpdated(undefined)}>Saved <span className="picks-updated">{picksUpdated}</span> picks!</Alert>}
      </div>
      <Box>
        <DataGrid getRowId={(c) => c.seriesId}
          autoHeight
          rowHeight={30}
          editMode="row"
          hideFooter={true} 
          rows={picks} 
          columns={columns} 
          disableRowSelectionOnClick 
          processRowUpdate={processRowUpdate} />
      </Box>
    </div>
  );
};



